'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _react = require('react');

var _core = require('@material-ui/core');

var _jsxRuntime = require('react/jsx-runtime');

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr)))
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (
      var _i = arr[Symbol.iterator](), _s;
      !(_n = (_s = _i.next()).done);
      _n = true
    ) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DeactivateDialog = function DeactivateDialog(_ref) {
  var open = _ref.open,
    setOpen = _ref.setOpen,
    disabled = _ref.disabled,
    onToggleStatus = _ref.onToggleStatus,
    title = _ref.title,
    content = _ref.content,
    _ref$descriptionLabel = _ref.descriptionLabel,
    descriptionLabel =
      _ref$descriptionLabel === void 0 ? 'Description' : _ref$descriptionLabel,
    _ref$cancelLabel = _ref.cancelLabel,
    cancelLabel = _ref$cancelLabel === void 0 ? 'Cancel' : _ref$cancelLabel,
    _ref$confirmLabel = _ref.confirmLabel,
    confirmLabel = _ref$confirmLabel === void 0 ? 'Confirm' : _ref$confirmLabel;

  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    reason = _useState2[0],
    setReason = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    reasonError = _useState4[0],
    setReasonError = _useState4[1];

  var onCloseDialog = (0, _react.useCallback)(
    function () {
      setOpen(false);
    },
    [setOpen]
  );

  var onChangeReason = function onChangeReason(event) {
    setReason(event.target.value);

    if (reasonError) {
      setReasonError(false);
    }
  };

  var onConfirm = (0, _react.useCallback)(
    function () {
      if (!reason) {
        setReasonError(true);
        return;
      }

      onToggleStatus(false, reason);
    },
    [onToggleStatus, reason]
  );
  return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_core.Dialog, {
    open: open,
    onClose: onCloseDialog,
    children: [
      /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.DialogTitle, {
        children: title,
      }),
      /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_core.DialogContent, {
        children: [
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Box, {
            my: 2,
            dangerouslySetInnerHTML: {
              __html: content,
            },
          }),
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.TextField, {
            onChange: onChangeReason,
            value: reason,
            multiline: true,
            fullWidth: true,
            rows: 4,
            label: descriptionLabel,
            required: true,
            error: reasonError,
            variant: 'outlined',
          }),
        ],
      }),
      /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_core.DialogActions, {
        children: [
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Button, {
            variant: 'text',
            disabled: disabled,
            onClick: onCloseDialog,
            type: 'button',
            children: cancelLabel,
          }),
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Button, {
            variant: 'contained',
            disabled: disabled,
            onClick: onConfirm,
            type: 'button',
            color: 'primary',
            children: confirmLabel,
          }),
        ],
      }),
    ],
  });
};

var _default = /*#__PURE__*/ (0, _react.memo)(DeactivateDialog);

exports.default = _default;

//# sourceMappingURL=index.js.map
